// import { Form } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { getReconciliationData, setReconciliationClaimDetail, setReconciliationPageRange, setReconciliationStartIndex } from '../../../../store/actions/reconciliationAction';
import { TABLE_SIZE_MIDDLE } from '../../../../shared/constants/crmConstants';
import { Empty, Form, Pagination, Skeleton, Table } from 'antd';
import { fetchInpatientStatusList } from '../../../../store/actions/lookUpAction';
import { getTableBasedOnConfig } from '../../../crm/inPatient/service/crmUtils';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { getReconciliationTableMapping } from '../../../../shared/constants/reconciliationConstants';
import { useHistory } from 'react-router-dom';
import { base64UrlEncode } from '../../../../utils/utility';

const ReconciliationTable = (): ReactElement => {
  const {insurerName, tpaId, centerId : centerID, utrDate, dod, utrNumber: utrNo, searchKey, reconciliationDetails, viewId,
    columnFilters: filters, statusFilters, sortingKey, startIndex, range, reconciliationStatusList, totalSettledClaims, isTableLoading,
    totalUTRMappedClaims}
    = useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const [claimForm] = Form.useForm();
  const reconciliationTableMapping = getReconciliationTableMapping();

  const [reconColumns, setReconColumns] = useState([] as any);
  const dispatch = useDispatch();
  const history = useHistory();

  const appDetail = ApplicationDetail.instance;
  const appDetailModel: ApplicationDetailModel = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});
  useEffect((): any => {
    const payload = {
      providerId: appDetail.getProviderId(),
      insurerName,
      tpaId,
      centerID,
      utrDate,
      dod,
      utrNo,
      viewId,
      searchKey,
      filters,
      statusFilters,
      sortingKey,
      startIndex,
      range,
    };
    dispatch(getReconciliationData(payload));
  }, [insurerName, tpaId, centerID, utrDate, dod, utrNo, searchKey, startIndex, range, viewId]);
  useEffect((): any => {
    if (!reconciliationStatusList || reconciliationStatusList.length === 0) {
      dispatch(fetchInpatientStatusList());
    }
  }, []);

  const onRowClick = (event: any, record: any, rowIndex: any): any => {
  history.push(`/reconciliation/reconciliation-new/detail/${base64UrlEncode(JSON.stringify(record))}`);

   dispatch(setReconciliationClaimDetail(record));

  };
  const pageChange = (pageNumber: any, pageSize: any): any => {
    dispatch(setReconciliationStartIndex(pageNumber));
    dispatch(setReconciliationPageRange(pageSize));
  };

  const blankArr = Array(10).fill(0);

  useEffect((): any => {
    if (viewId === 3) {
      const UTRViewList = ['utrNumber', 'insurerName', 'reconciliationStatus', 'utrAmount', 'utrDate'];
      const UTRCols = [] as any;
      Object.values(reconciliationTableMapping).filter((col: any): any => { if (UTRViewList.includes(col.key)) { UTRCols.push(col); } });
      setReconColumns(UTRCols);
    } else {
      const filteredTable = getTableBasedOnConfig(appDetailModel.getReconciliationIPConfig(), reconciliationTableMapping);
      setReconColumns([...filteredTable]);
    }
  }, [appDetailModel, viewId]);

  return (<>
    <Form form={claimForm}>
      <Table
        data-testid="reconciliation-list"
        size={TABLE_SIZE_MIDDLE}
        columns={ reconColumns }
        dataSource={ reconciliationDetails }
        pagination={false}
        onRow={(record: any, rowIndex: any): any => {return viewId !== 3 ? {
            onClick: (event: any): any => onRowClick(event, record, rowIndex),
          } : {};
        }}
        locale={{
          emptyText: (
            isTableLoading ?
              <div className="full-skelton-in-list">
                {blankArr.map((...params: any[]): any =>
                  <Skeleton
                    key={params[1]}
                    active={true}
                    paragraph={{ rows: 0 }}
                  />,
                )}
              </div>
              : <Empty />
          ),
        }}
      />
    </Form>
    {(totalSettledClaims > 0 || totalUTRMappedClaims > 0) && <Pagination
        data-testid="pagination"
        showSizeChanger={true}
        onChange={pageChange}
        defaultCurrent={1}
        current={startIndex}
        total={viewId === 3 ? totalUTRMappedClaims : totalSettledClaims}
        className="mt-md text-center"
      />}
  </>);
};
export default ReconciliationTable;
